import { combineSlices, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authCreateAccountSlice from './Slice/CreateAccountSlice';
import authSlice from './Slice/AuthSlice';
import authDialogConfigSlice from './Slice/DialogSlice';
import allParameterSlice from './Slice/AllParameter';
import { ProfileAPI } from './api/ProfileAPI';
import { LoginAPI } from './api/LoginAPI';
import { AuftragAPI } from './api/AuftragAPI';
import { AdminProfileAPI } from './api/AdminProfileAPI';
import { StammdatenAPI } from './api/StammdatenAPI';
import { UserRoleAPI } from './api/UserRoleAPI';
import { TicketAPI } from './api/TicketAPI';
import { FakturaAPI } from './api/FakturaAPI';

const authReducers = combineSlices(
    authSlice
    , authDialogConfigSlice
    , authCreateAccountSlice
);

export const store = configureStore({
    reducer: {
        authSlice: authReducers,
        authReducer: authReducers,

        allParameter: allParameterSlice.reducer,

        [LoginAPI.reducerPath]: LoginAPI.reducer,
        [AuftragAPI.reducerPath]: AuftragAPI.reducer,
        [ProfileAPI.reducerPath]: ProfileAPI.reducer,
        [AdminProfileAPI.reducerPath]: AdminProfileAPI.reducer,
        [StammdatenAPI.reducerPath]: StammdatenAPI.reducer,
        [UserRoleAPI.reducerPath]: UserRoleAPI.reducer,
        [TicketAPI.reducerPath]: TicketAPI.reducer,
        [FakturaAPI.reducerPath]: FakturaAPI.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        }).concat(
            AdminProfileAPI.middleware,
            LoginAPI.middleware,
            AuftragAPI.middleware,
            ProfileAPI.middleware,
            StammdatenAPI.middleware,
            UserRoleAPI.middleware,
            TicketAPI.middleware,
            FakturaAPI.middleware
        )
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;